import React from 'react';
import Icon from 'components/Icon';

export type BackButtonProps = {
  className?: string;
  style?: React.CSSProperties;
  icon?: string;
  backText?: string;
  backClassName?: string;
  onClick: () => void;
};

export const BackButton = ({
  style,
  className = '',
  icon = 'arrow_left',
  backText = 'Back',
  backClassName = '',
  onClick,
}: BackButtonProps) => {
  return (
    <button
      className={className || 'absolute right-4 top-8 text-black text-lg'}
      onClick={onClick}
      style={style}
    >
      <Icon name={icon} className='mr-2' />
      <span className={backClassName}>{backText}</span>
    </button>
  );
};
